export type RemoveEmpty<T> = Partial<{
  [K in keyof T]: Exclude<T[K], null | undefined | ''>;
}>;

export function removeEmptyKeys<T extends object>(obj: T): RemoveEmpty<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined && value !== ''
    )
  ) as RemoveEmpty<T>;
}
